import {
  ITextProps,
  MarginLeftMap,
  MarginRightMap,
  PaddingLeftMap,
  PaddingRightMap,
  TextColor,
  TextColorMap,
  TextSpace,
  TextWeight,
  TextWeightMap,
} from "../types/textTypes"

const mapStylesFromProps = (props: ITextProps): string => {
  const {
    color = TextColor.Black,
    weight = TextWeight.Regular,
    marginLeft = TextSpace.None,
    marginRight = TextSpace.None,
    paddingLeft = TextSpace.None,
    paddingRight = TextSpace.None,
  } = props
  return `${TextColorMap[color]} ${TextWeightMap[weight]} ${PaddingRightMap[paddingRight]} ${PaddingLeftMap[paddingLeft]} ${MarginLeftMap[marginLeft]} ${MarginRightMap[marginRight]}`
}

export default mapStylesFromProps
